'use client';

import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import BrandedLeading from 'ui/src/components/BrandedLeading';
import LinkedinIcon from 'ui/src/icons/DS/_Linkedin';
import FacebookIcon from 'ui/src/icons/DS/_Facebook';
import XIcon from 'ui/src/icons/XSquareIcon';
import InstagramIcon from 'ui/src/icons/DS/_Instagram';
import YoutubeIcon from 'ui/src/icons/DS/_Youtube';
import SocialMediaItem, { SocialMediaItemProps } from './SocialMediaItem';
import useFooterThemes from './themes';

const socialMedia: SocialMediaItemProps[] = [
  {
    name: 'Linkedin',
    link: 'https://www.linkedin.com/company/bairesdev/',
    className: 'text-white',
    Icon: LinkedinIcon,
  },
  {
    name: 'Facebook',
    link: 'https://www.facebook.com/bairesdev/',
    Icon: FacebookIcon,
  },
  {
    name: 'X',
    link: 'https://x.com/bairesdev/',
    Icon: XIcon,
  },
  {
    name: 'Instagram',
    link: 'https://www.instagram.com/bairesdev/',
    Icon: InstagramIcon,
  },
  {
    name: 'Youtube',
    link: 'https://www.youtube.com/BairesDevSolutions/',
    Icon: YoutubeIcon,
  },
];

type SocialLinksProps = {
  hasTitle?: boolean;
  withFullStops?: boolean;
  containerClasses?: string;
};

export default function SocialLinks({ hasTitle, withFullStops, containerClasses }: SocialLinksProps) {
  const { footerSocialContainerClasses, footerSocialTitleClasses } = useFooterThemes();

  return (
    <section className={twMerge(footerSocialContainerClasses, containerClasses)}>
      {hasTitle && (
        <BrandedLeading as="p" classes={twMerge(footerSocialTitleClasses)} addBrandedFullStop={withFullStops}>
          Follow us
        </BrandedLeading>
      )}
      <ul className="flex gap-4">
        {socialMedia.map((el: SocialMediaItemProps) => (
          <SocialMediaItem key={el.name} name={el.name} link={el.link} className={el.className} Icon={el.Icon} />
        ))}
      </ul>
    </section>
  );
}
